import classNames from "classnames";
import Image from "next/image";

import PersonIcon from "assets/icons/person-crop-circle.svg";

import styles from "./UserAvatar.module.css";

type PropTypes = {
  icon?: React.ReactElement;
  avatar?: string;
  alt: string;
  size: "small" | "big";
};

const UserAvatar = ({ icon = <PersonIcon className="icon" />, avatar, alt, size }: PropTypes) => (
  <div
    className={classNames(styles.avatarWrapper, {
      [styles.big]: size === "big",
      [styles.withIcon]: avatar === undefined,
    })}
  >
    {avatar !== undefined ? <Image src={avatar} alt={alt} width="160" height="160" /> : icon}
  </div>
);

export default UserAvatar;
